import { useState, useEffect } from 'react';
import Header from '../../components/layout/Header';
import Body from '../../components/layout/Body';
import Table from '../../components/layout/Table';
import { Button } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { useURLParams } from '../../contexts/ParamsContext';
import { useNotice } from '../../contexts/NoticeContext';

import {
    fetchPostTypes,
    deletePostType,
} from '../../utils/api';

const PostTypeList = () => {
    const { updateUrlParams } = useURLParams();
    const { showNotice } = useNotice();
    const [postTypes, setPostTypes] = useState([]);

    useEffect(() => {
        fetchPostTypes()
            .then(setPostTypes)
            .catch((error) => {
                showNotice(
                    error?.message || __('Something went wrong while fetching post types.', 'voxycure-framework'),
                    'error'
                );
            });
    }, []);

    const handleDeletePostType = (id) => {
        if (!confirm(__('Are you sure you want to delete this post type?', 'voxycure-framework'))) return;

        deletePostType(id)
            .then(() => {
                setPostTypes((prev) => prev.filter((pt) => pt.id !== id));
                showNotice(__('Post type deleted successfully.', 'voxycure-framework'), 'success');
            })
            .catch((error) => {
                showNotice(
                    error?.message || __('Something went wrong while deleting post type.', 'voxycure-framework'),
                    'error'
                );
            });
    };

    return (
        <>
            <Header>
                <h2 className="voxycure-editor__header-title">
                    {__('All Post Types', 'voxycure-framework')}
                </h2>
                <Button
                    className="components-button is-primary voxycure-button"
                    onClick={() => updateUrlParams({ view: 'new-post-type' })}
                >
                    {__('Add New Post Type', 'voxycure-framework')}
                </Button>
            </Header>

            <Body>
                <Table
                    columns={[
                        { key: 'name', label: __('Post Type Name', 'voxycure-framework') },
                        { key: 'status', label: __('Status', 'voxycure-framework') },
                        { key: 'actions', label: __('Actions', 'voxycure-framework') },
                    ]}
                    data={postTypes}
                    emptyMessage={__('No post types found. Try creating a new one.', 'voxycure-framework')}
                    renderRow={(pt) => (
                        <tr key={pt.id} style={{ borderBottom: '1px solid #eee' }}>
                            <td style={{ padding: '0.75rem' }}>{pt.name}</td>
                            <td style={{ padding: '0.75rem' }}>{pt.status}</td>
                            <td style={{ padding: '0.75rem' }}>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <Button
                                        isSmall
                                        isSecondary
                                        onClick={() => updateUrlParams({ view: 'edit-post-type', id: pt.id })}
                                    >
                                        {__('Edit', 'voxycure-framework')}
                                    </Button>
                                    <Button
                                        isSmall
                                        isDestructive
                                        onClick={() => handleDeletePostType(pt.id)}
                                    >
                                        {__('Delete', 'voxycure-framework')}
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    )}
                />
            </Body>
        </>
    );
};

export default PostTypeList;
